import { connect } from 'react-redux';
import { getSettings } from '../../selectors/settings';
import { getLocation, getConvo, hasLinks } from '../../selectors/conversation';
import { LocationState, RootState, SettingsState } from '../../typedefs/store';
import SurveyFactory from './SurveyFactory';
import { setSurveyScore, removeConversation } from '../../actions';

const mapStateToProps = (state: RootState) => {
    const location: LocationState = getLocation(state);
    const settings: SettingsState = getSettings(state);
    const convo = getConvo(state);
    return {
        messageListType: settings.messageListType,
        avatar: convo.avatar,
        name: convo.users.length > 0 ? convo.users[0].name : location.name,
        hasLinks: hasLinks(state),
    };
};

const mapDispatchToProps = {
    setSurveyScore,
    removeConversation,
};

export default connect(mapStateToProps, mapDispatchToProps)(SurveyFactory);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/SurveyContainer.tsx